const ROOT = 'properties/albums/'

export default {
	arrayListFilesByAlbumsTypes: `${ROOT}list-files-by-albums-types`,
	show: `${ROOT}`
}
